import {
  initAutterBrowser,
  captureException,
  captureMessage,
  trackEvent,
  setUser,
  setContext,
  flush,
} from "@autter/runtime-browser";

// Same-origin relay route on the backend. In dev, Vite proxies `/api` to the
// local Hono Worker; in prod the full-stack Worker serves both the SPA and
// `/api`. The backend attaches the private `AUTTER_RUNTIME_KEY` server-side,
// so no key ever reaches this bundle.
const RELAY_ENDPOINT = "/api/autter-runtime";

const SERVICE_NAME = "autter-same-boat-frontend";

export function initAutter() {
  // Only initialise in production builds, matching the PostHog gate: the dev
  // server shares this relay, so without this a local crash or event would
  // write into the production project.
  if (!import.meta.env.PROD) return;
  initAutterBrowser({
    endpoint: RELAY_ENDPOINT,
    service: SERVICE_NAME,
    environment: import.meta.env.MODE,
  });
}

export { captureException, captureMessage, trackEvent, setUser, setContext, flush };
